export const actionButtonProps = {
  editor: {
    type: Object,
    required: true,
  },
  icon: {
    type: String,
    default: undefined,
  },
  tooltip: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    default: undefined,
  },
  action: {
    type: Function,
    default: undefined,
  },
  isActive: {
    type: Function,
    default: undefined,
  },
}

export const extActionButtonProps = {
  editor: {
    type: Object,
    required: true,
  },
  t: {
    type: Function,
    required: true,
  },
}
